import React, { useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import { LockIcon } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { AuthDialog } from './AuthDialog';
interface RequireAuthProps {
  /** Nom du module, affiché dans l'écran et le dialogue de connexion. */
  label: string;
  children: React.ReactNode;
}

/** Protège un module : sans session, affiche l'écran sobre et le dialogue de connexion. */
export function RequireAuth({
  label,
  children
}: RequireAuthProps) {
  const {
    isAuthenticated,
    login
  } = useAuth();
  const [dialogOpen, setDialogOpen] = useState(true);
  if (isAuthenticated) return <>{children}</>;
  return <main className="bg-white" data-id="element-369" data-mp="2yusivvvy7bbq">
      <div className="mx-auto max-w-[680px] px-5 py-24 text-center lg:px-10" data-id="element-370" data-mp="2tuo4cbeloqo5">
        <span className="mx-auto grid h-14 w-14 place-items-center rounded-full bg-ville-sand text-ville-deep" aria-hidden="true" data-id="element-371" data-mp="1ndj4hnrof9ha">
          <LockIcon className="h-6 w-6" data-id="element-372" data-mp="1idemtuf188ph" />
        </span>
        <h1 className="mt-5 text-3xl font-extrabold tracking-tight text-ville-navy" data-id="element-373" data-mp="1trop10xctezi">
          {label} est réservé aux citoyens connectés
        </h1>
        <p className="mt-2 text-[17px] text-slate-600" data-id="element-374" data-mp="1xrfmfnhdytd0">
          Connectez-vous ou créez votre compte en quelques secondes avec votre courriel ou votre numéro de
          mobile.
        </p>
        <button type="button" onClick={() => setDialogOpen(true)} className="mt-6 inline-flex items-center gap-2 rounded-full bg-ville-navy px-6 py-3 text-sm font-bold text-white transition-transform duration-150 ease-ville hover:-translate-y-0.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo focus-visible:ring-offset-2" data-id="element-375" data-mp="1or0qlu6spvv9">
          Se connecter
        </button>
      </div>

      <AnimatePresence data-id="element-376" data-mp="r5d01px0u7rn">
        {dialogOpen && <AuthDialog key="auth-dialog" moduleLabel={label} onClose={() => setDialogOpen(false)} onSuccess={identifier => {
        login(identifier);
        setDialogOpen(false);
      }} data-id="element-377" data-mp="r5v7zjt1qafe" />}
      </AnimatePresence>
    </main>;
}